import React from 'react'
import ReactDOM from 'react-dom'

const withPortal =
  (WrappedComponent) =>
  ({ ...props }) => {
    return ReactDOM.createPortal(<WrappedComponent {...props} />, document.getElementById('portal'))
  }

export default withPortal
